<script>
import PropTypes from '@znck/prop-types'
export default {
  props: {
    block: PropTypes.shape({
      type: PropTypes.string.isRequired,
      value: PropTypes.any
    })
  },
  created() {
    this.$emit('create', this.block)
  },
  mounted() {
    this.$emit('mounted', this.block)
  }
}
</script>
